import IconUndo from '@picsart/icons/IconUndo';
import IconRedo from '@picsart/icons/IconRedo';

import useCopyOnClick from '../../../../hooks/useCopyOnClick';
import { useFontDataHistory } from '../../../../hooks/editHistory/useFontDataHistory';
import Button from '../../../core/Button';

import useStyles from './styles';
import { EditorFooterProps } from './types';
import { HistoryButton } from './HistoryButton';
import { LinkButton } from './LinkButton';

function EditorFooter({
  data,
  onCopyClick,
  onCopyError,
  copyShareDisabled,
  onLinkButtonClick,
  setData,
  analytics,
}: EditorFooterProps) {
  const classes = useStyles();
  const [text] = data;
  const [justCopied, buttonClick] = useCopyOnClick(text, onCopyClick, onCopyError);
  const canUndo = useFontDataHistory((state) => state.prev.length > 1);
  const canRedo = useFontDataHistory((state) => state.next.length > 0);
  const undo = useFontDataHistory((state) => state.undo);
  const redo = useFontDataHistory((state) => state.redo);

  return (
    <div className={classes.footer}>
      <div className={classes.history}>
        <HistoryButton
          Icon={IconUndo}
          enabled={canUndo}
          getData={undo}
          setData={setData}
          tooltipText="Undo"
          analytics={analytics}
        />
        <HistoryButton
          Icon={IconRedo}
          enabled={canRedo}
          getData={redo}
          setData={setData}
          tooltipText="Redo"
          analytics={analytics}
        />
      </div>
      <div className={classes.buttonContainer}>
        {onLinkButtonClick && (
          <LinkButton
            copyShareDisabled={copyShareDisabled}
            onLinkButtonClick={onLinkButtonClick}
            data={data}
          />
        )}
        <Button className={classes.copyButton} disabled={copyShareDisabled} onClick={buttonClick}>
          {justCopied ? 'Copied!' : 'Copy'}
        </Button>
      </div>
    </div>
  );
}

export default EditorFooter;
